<template>
    <div class="container" v-if="visible" @click.stop="close" @touchmove.prevent>
        <div id="modal" class="modal modules-background" :style="`height: ${height + 'px'}`"  @click.stop="">
            <slot></slot>
            <div class="bottom bottom-cancel" v-if="showCancelBtn">
                <div class="cancelBtn" @click.stop="close"> 取消</div>
            </div>
        </div>
    </div>
</template>
<script lang="ts">
import {defineComponent, toRefs, watchPostEffect} from 'vue'
import {useThemeStore} from '@/store/theme'

export default defineComponent({
    props: {
        visible: {
            type: Boolean,
            value: false
        },
        height: {
            type: Number,
            value: 300
        },
        showCancelBtn: {
            type: Boolean,
            default: true
        }
    },
    emits: ['close'],
    setup(props, context) {
        const themeStore = useThemeStore()
        const state = {theme: themeStore.theme}
        watchPostEffect(() => {
            if (props.visible) {
                document.body.style.overflow = 'hidden'
            } else {
                document.body.style.overflow = ''
            }
        })
        const close = () => {
            context.emit('close')
        }
        return {
            ...toRefs(state),
            close
        }
    }
})
</script>

<style scoped>
.container {
    width: 100%;
    height: 100%;
    max-width: 750px;
    background: rgba(0, 0, 0, 0.5);
    position: fixed;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    z-index: 99;
}

.modal {
    width: 100%;
    border-radius: 12px 12px 0 0;
    position: absolute;
    bottom: 0;
    left: 0;
    animation: bottom 0.2s;
}

.bottom {
    width: 100%;
    display: flex;
    justify-content: center;
    /* position: absolute; */
    height: 48px;
    /* bottom: 35px; */
    font-size: 14px
}

.cancelBtn {
    display: flex;
    align-items: center;
    justify-content: center;
    width:100%;
    height:100%
}

@keyframes bottom {
    0% {
        bottom: -100%;
    }
    100% {
        bottom: 0%;
    }
}
</style>
